module.exports = __webpack_public_path__ + "static/media/size-classic.f07a0044.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/invitations/size-classic.svg
// module id = 1205
// module chunks = 70